import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

const STEP_KEYS = ["log", "context", "generate", "exportShare"];

export default function WorkflowStepper({ current = 2 }) {
  const { t } = useTranslation();
  const STEPS = STEP_KEYS.map((k) => t(`workflow.${k}`));
  return (
    <div className="flex items-center w-full mb-8" data-testid="workflow-stepper">
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            <div className="flex items-center gap-2.5">
              <div
                className={`h-8 w-8 rounded-full flex items-center justify-center text-sm font-semibold border transition-colors duration-200 ${
                  done ? "bg-[#202123] border-[#202123] text-white"
                  : active ? "bg-white border-[#C5C5D0] text-[#202123]"
                  : "bg-white border-slate-300 text-slatebody"
                }`}
              >
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <span className={`font-display text-sm font-medium hidden sm:inline ${active || done ? "text-navy" : "text-slatebody"}`}>
                {label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div className={`h-px flex-1 mx-3 ${done ? "bg-[#C5C5D0]" : "bg-slate-300"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
